import {
  StripeCardNumberElementChangeEvent,
  StripeCardExpiryElementChangeEvent,
  StripeCardCvcElementChangeEvent,
} from '@stripe/stripe-js'
import { useState } from 'react'
import { convertStipeErrorForInputErrorMessage, StripeCardFormErrors } from 'utils/stripeUtils'

export function useStripeCardFields() {
  const [cardnumberEvent, onCardNumberChange] = useState<StripeCardNumberElementChangeEvent>()
  const [expiryEvent, onCardExpiryChange] = useState<StripeCardExpiryElementChangeEvent>()
  const [cvcEvent, onCvcChange] = useState<StripeCardCvcElementChangeEvent>()

  const cardNumberError = convertStipeErrorForInputErrorMessage({
    name: 'cardnumber',
    error: cardnumberEvent?.error,
  })

  const cardExpiryError = convertStipeErrorForInputErrorMessage({
    name: 'exp-date',
    error: expiryEvent?.error,
  })

  const cardCvcError = convertStipeErrorForInputErrorMessage({
    name: 'cvc',
    error: cvcEvent?.error,
  })

  const errors: StripeCardFormErrors = {
    ...cardNumberError,
    ...cardExpiryError,
    ...cardCvcError,
  }

  const isValid = [cardnumberEvent, expiryEvent, cvcEvent].every(
    (evt) => evt?.complete && !evt?.empty
  )

  return {
    errors,
    isValid,
    onCardNumberChange,
    onCardExpiryChange,
    onCvcChange,
  }
}
